// Telegram message model types - converted from Go backend models

import type { TelegramMessageID } from '@/models/ids';
import type { RFC3339, Timestamps } from '@/models/base-types';

export const TelegramMessageStatus = {
    WAITING: 'WAITING',
    SUCCESS: 'SUCCESS',
    FAILED: 'FAILED'
} as const;

export type TelegramMessageStatus = typeof TelegramMessageStatus[keyof typeof TelegramMessageStatus];

// TelegramEmbedImage represents an image in a Telegram message
export interface TelegramEmbedImage {
    url: string;
}

// TelegramEmbed represents a Telegram rich message object
export interface TelegramEmbed {
    title: string | null;
    description: string | null;
    url: string | null;
    image: TelegramEmbedImage | null;
    thumbnail: TelegramEmbedImage | null;
}

export interface TelegramMessage extends Timestamps {
    id: TelegramMessageID;

    chatID: string;
    content: string;

    embeds: TelegramEmbed[];

    status: TelegramMessageStatus;
    lastError: string | null;
    sentAt: RFC3339 | null;
    sendTryCount: number;

    created: RFC3339;
    updated: RFC3339 | null;
    deleted: RFC3339 | null;
}

// List request/response types
export interface ListTelegramMessagesOptions {
    status?: TelegramMessageStatus;
    chatId?: string;
    next?: string;
    limit?: number;
}

export interface ListTelegramMessagesResponse {
    messages: TelegramMessage[];
    next: string;
    total: number;
}

// Request bodies
export interface SendTelegramMessageRequest {
    chatId: string;
    content: string;
}
